


















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { HeaderList } from '@/components/Table/TableModel';
import { Picture } from '@/components/atoms';

import Table from '@/components/molecules/Table/Table.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';

import AdminService from '@/api/AdminService';

import { Pagination, SortController } from '@/utils/Pagination';
import DateUtils from '@/utils/DateUtils';
import eventBus from '@/utils/eventBus';
import EmptyImageIcon from '@/components/icons/EmptyImage.vue';

@Component({
  components: {
    Table,
    TableHeader,
    TableRow,
    TableCell,
    Picture,
    EmptyImageIcon
  }
})
export default class OfferList extends Vue {
  @Prop(String) readonly businessId?: string;

  service: AdminService = new AdminService();
  pagination = new Pagination(this.formatRow);
  sort = new SortController();
  query: any = {};
  headers = [
    new HeaderList(`Date`, 'createdAt', '12px 12px 12px 32px'),
    new HeaderList(`Image`, 'none', '12px'),
    new HeaderList(`Title`, 'title', '12px'),
    new HeaderList(`status`, 'status', '12px 32px 12px 12px', 'right')
  ];

  formatRow(row: any) {
    return {
      ...row,
      date: DateUtils.formattedDate({
        date: row.createdAt,
        applyTimezone: true
      }),
      image: {
        url: row.image ? row.image.publicPath.small : '',
        id: row.image ? row.image.id : null
      }
    };
  }

  handleOpenOfferDetail(row: Record<string, any>) {
    this.$emit('clickOffer', row);
  }

  updateSort(field: string) {
    this.sort.update(field);
    this.query = {
      ...this.query,
      sort: this.sort.toQueryParams().sortBy,
      order: this.sort.toQueryParams().sortOrder
    };
  }

  @Watch('query')
  refreshPagination(query: any) {
    this.reloadOfferList(query);
  }

  mounted() {
    this.query = {
      ...this.query
    };
    this.pagination.setPaginationTarget(this.$refs.target as HTMLElement);

    eventBus.$on('reloadOfferList', this.reloadOfferList);
  }

  beforeDestroy() {
    eventBus.$off('reloadOfferList', this.reloadOfferList);
  }

  reloadOfferList(query?: any) {
    this.pagination.refresh(
      `/super-admin/offer?businessId=${this.businessId}`,
      query || this.query
    );
  }
}
